export default {
      id: "logo-mas-footer-usage",
      viewBox: "0 0 63.85 27.3",
      url: __webpack_public_path__ + "../images/sprites.svg#logo-mas-footer",
      toString: function () {
        return this.url;
      }
    }